import React,{useState,useRef,useEffect} from "react";
import { createContext } from "react";
import  secureLocalStorage  from  "react-secure-storage";
import { WebSocketRoomProvider } from "./roomprovidercontext";
import { useContext } from "react";
import { useSelector,useDispatch } from "react-redux";
import { RoomIdProvider } from "../redux/actions/websocket_actions/roomId_action";
export const WebsocketContext = createContext(false, null, () => {});


export const WebsocketProvider = ({ children }) => {
    const [isReady, setIsReady] = useState(false);
    const {roomId} = useSelector((state)=>state.roomIdReducer);
    // console.log(roomid,"from websocker")
    // const {roomId, setroomId} = useContext(WebSocketRoomProvider)
    // console.log(roomId,"room id from socker context after set")

    const [val, setVal] = useState(JSON.stringify({action:null,data:null}));
    const ws = useRef(null);
  
    useEffect(() => {
        // const room = secureLocalStorage.getItem("room")
        // const room = "participants"
        // const url = `ws://localhost:8000/ws/v1/${roomId}`;
        // const url = `ws://13.126.44.109:8000/ws/v1/${roomId}`;
        const url = `${process.env.REACT_APP_BASE_BACKEND_SOCKET_API_URL}${roomId}`;


        const socket = new WebSocket(url);
  
        socket.onopen = () => setIsReady(true);
        socket.onclose = () => setIsReady(false);
        socket.onmessage = (event) => setVal(JSON.parse(event.data));
    
        ws.current = socket;
  
      return () => {
        socket.close();
      };
    }, [roomId]);
  
    const ret = ws.current ? [isReady, val, ws.current.send.bind(ws.current)]:[null,val,null];
  
    return (
      <WebsocketContext.Provider value={ret}>
        {children}
      </WebsocketContext.Provider>
    );
  };

